
import state from './moduleElomarkUserManagementState'
import mutations from './moduleElomarkUserManagementMutations'
import actions from './moduleElomarkUserManagementActions'
import getters from './moduleElomarkUserManagementGetters'

export default {
  isRegistered: false,
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters
}

